import script from "./parent.vue?vue&type=script&setup=true&lang=js"
export * from "./parent.vue?vue&type=script&setup=true&lang=js"

import "./parent.css?vue&type=style&index=0&id=20978b28&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-jw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20978b28"]])

export default __exports__